import React from 'react';
import { Link } from 'react-router-dom';
import icon1 from '../assets/icon1.png';
import icon2 from '../assets/icon2.png';
import icon3 from '../assets/icon3.png';

function Footer() {
    return (
        <footer>
            <nav>
                <Link to="/"><img src={icon1} alt=""/>Главная</Link>
                <Link to="/game"><img src={icon2} alt=""/>Загрузка</Link>
                <Link to="/rules"><img src={icon3} alt=""/>О конкурсе</Link>
            </nav>
        </footer>
    );
}

export default Footer;